import {ThemeProvider} from "@mui/material/";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {theme} from "./theme"
import App from './App';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
